import { type AppState } from '../stores';

export const getStatusCode = (state: AppState) => state?.status?.code;
export const getSessionTimeout = (state: AppState) => state?.status?.sessionTimeout;
